import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth';
import style from './style';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: auth,
    style: style
  }
})
